import axios from 'axios';

import { API_URL, BASE_URL } from '../config';

export function isAxiosError(err) {
    return err.status && err.request;
}

const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export const instanceBase = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export const setGoogleTokens = (id_token, access_token) => {
    instance.defaults.headers.common['googletoken'] = id_token;
    instanceBase.defaults.headers.common['googletoken'] = id_token;

    if (access_token) {
        instance.defaults.headers.common['google-access-token'] = access_token;
        instanceBase.defaults.headers.common['google-access-token'] = access_token;
    }
};

export const setLtiLaunch = () => {
    instance.defaults.headers.common['lti-launch'] = 'true';
    instanceBase.defaults.headers.common['lti-launch'] = 'true';
};

export const setLazeLaunch = (userName) => {
    instance.defaults.headers.common['guestUserName'] = userName;
    instanceBase.defaults.headers.common['guestUserName'] = userName;
};

export default instance;
